export default {
    url: '/lessons',
    template: '<materials-lessons/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/materials/lessons/index.js